export default "__VITE_ASSET__DmDi6Qz___"